import { useMutation } from 'react-query';
import { updateCustomer } from 'src/services/CRM/customers';

export default function UpdateCustomer() {
  return useMutation(({ id, data }: any) => updateCustomer(id, data));
}
